import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';
import { EnvironmentService } from '../../services/environmentService';


@inject(Router, EnvironmentService)
export class CaseStudyStart {
    constructor(router, envService) {
        this.router = router;
        this.envService = envService;
        

        this.validateName = false;
        this.validateEmail = false;
        this.savingUserInfo = false;

    
        //this.home_url = window.home_url;
        this.home_url = window.location.origin;

        this.capture_bottom_img = "images/capture_bottom.png";

        if(window.whitelabel) {
            this.capture_bottom_img = "api/whitelabel/getFile?file=capture_bottom";
        }

    }


    activate(model, route) {

        

        if (model.method)
            this.method = model.method;

        if(model.uploadonly && model.uploadonly == 1)
            this.uploadOnly = true

        this.capture_key = model.key;

        if(route.settings && route.settings.captureType)
            this.captureType = route.settings.captureType;
        else 
            this.captureType = 0;

        if(this.captureType == 2) {
            this.maxRecordTime = 95;
        } else {
            this.maxRecordTime = 55;
        }


        this.api = new TestimonialCaptureAPI(this.captureType);       

    }

    attached() {
        if (this.capture_key) {
       
        this.api.getByCaptureKey(this.capture_key, this.saveLoadSuccess.bind(this), this.saveLoadError.bind(this));
       
        }


    }

    saveLoadSuccess(org_name, website, mlink_return_url, chrome_min_ver, nextQuestion, questionNum) {
        
        this.setData(org_name, mlink_return_url, chrome_min_ver, nextQuestion, questionNum);

        this.checkSupported();
        

    }

    saveLoadError(msg) {

        if(msg == "invalid key")
            this.router.navigate("/");
       

    }

    setData(org_name, mlink_return_url, chrome_min_ver, nextQuestion, questionNum) {
       
       
        this.org_name = org_name;
        this.mlink_return_url = mlink_return_url;
        this.chrome_min_ver = chrome_min_ver;
        this.nextQuestion = nextQuestion;
        this.questionNum = questionNum;
        
    }

    checkSupported() {
        if (this.envService.isMobile()) {
                
            var supportedChrome = false;

            if(this.envService.isChrome()){
                supportedChrome = true;
                
                if(this.chrome_min_ver) {
                    var version = this.envService.getBrowserVersion();
                    
                    supportedChrome = parseInt(this.chrome_min_ver) <= version;
                }
            }

            if (this.envService.isAndroid() && !supportedChrome) {
                if(this.envService.isChrome())
                    this.router.navigate("#/capture/unsupported");
                else
                    this.router.navigate("#/capture/unsupported?url=case/" + this.capture_key);
              
            }
        }
    }

    capture() {

       
        this.router.navigate('#/capture/video/case/' + this.capture_key);
    }





}